// extracted by mini-css-extract-plugin
module.exports = {"MobileViewRow":"MobileViewRow--ajnv-","IconWrapper":"IconWrapper--3Bi3R"};